import classNames from 'classnames';

interface IProps {
  isWhite?: boolean;
}

export const Spinner = ({ isWhite }: IProps) => {
  const classString = classNames('Spinner', { 'Spinner--white': isWhite });

  return (
    <div className={classString}>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
      <i></i>
    </div>
  );
};
